import { useState } from 'react'

import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { DialogPelaksanaanAppealRejectionPs } from 'app/KinerjaNotifikasiPage/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRejectionPs'
import { DialogPelaksanaanAppealApprovalPs } from 'app/KinerjaNotifikasiPage/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealApprovalPs'

import type {
  PelaksanaanAppealState,
  PelaksanaanAppealableStep,
  PelaksanaanState,
} from 'types/kinerja-ks-pelaksanaan'
import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

type Props = CardNotificationBaseProps & {
  appealState?: PelaksanaanAppealState
  ksName: string
  notificationId?: string
  step: PelaksanaanAppealableStep
  currentState: PelaksanaanState
  requestorNpsn: string
  period?: { year?: number; no?: number }
}

export function CardNotificationKsPelaksanaanAppealPs({
  appealState,
  ksName,
  notificationId,
  step,
  currentState,
  requestorNpsn,
  period,
  ...cardProps
}: Props) {
  const [activeDialog, setActiveDialog] = useState<
    'NONE' | 'APPEAL_APPROVAL' | 'APPEAL_REJECTION'
  >('NONE')

  const handleCloseDialog = () => setActiveDialog('NONE')

  const renderAppealResult = (state: Props['appealState']) => {
    switch (state) {
      case 'APPROVED':
        return (
          <Badge variant="success" className="mt-6">
            Pengajuan sudah diterima
          </Badge>
        )
      case 'REJECTED':
        return <Badge className="mt-6">Pengajuan sudah ditolak</Badge>
      default:
        return (
          <div className="flex space-x-6 mt-6">
            <Button
              size="sm"
              color="blue"
              onClick={() => setActiveDialog('APPEAL_APPROVAL')}
            >
              Terima dan nilai ulang dokumen
            </Button>
            <Button
              size="sm"
              color="blue"
              variant="ghost"
              onClick={() => setActiveDialog('APPEAL_REJECTION')}
            >
              Tolak pengajuan
            </Button>
          </div>
        )
    }
  }

  return (
    <CardNotificationBase {...cardProps}>
      {renderAppealResult(appealState)}

      <DialogPelaksanaanAppealApprovalPs
        isOpen={activeDialog === 'APPEAL_APPROVAL'}
        period={period}
        ksName={ksName}
        requestId={notificationId}
        step={step}
        onClose={handleCloseDialog}
        requestorNpsn={requestorNpsn}
        currentState={currentState}
      />

      <DialogPelaksanaanAppealRejectionPs
        isOpen={activeDialog === 'APPEAL_REJECTION'}
        period={period}
        ksName={ksName}
        requestId={notificationId}
        step={step}
        onClose={handleCloseDialog}
        requestorNpsn={requestorNpsn}
      />
    </CardNotificationBase>
  )
}
